module.exports = __webpack_public_path__ + "static/localiza-logo-b09fcf07e773f23f0e350adf3efe1428.png";